import { render, staticRenderFns } from "./StudentRelationList.vue?vue&type=template&id=019d3588&scoped=true"
import script from "./StudentRelationList.vue?vue&type=script&lang=js"
export * from "./StudentRelationList.vue?vue&type=script&lang=js"
import style0 from "./StudentRelationList.vue?vue&type=style&index=0&id=019d3588&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d3588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019d3588')) {
      api.createRecord('019d3588', component.options)
    } else {
      api.reload('019d3588', component.options)
    }
    module.hot.accept("./StudentRelationList.vue?vue&type=template&id=019d3588&scoped=true", function () {
      api.rerender('019d3588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentRelation/StudentRelationList.vue"
export default component.exports